import React, { useEffect, useState } from 'react';

const FLAVOR_LINES = [
	'Forging backend systems...',
	'Rolling for initiative...',
	'Applying buffs to Spline scene...',
	'Grinding XP in production...',
	'Loading quest log...',
];

const LoaderV2 = ({ progress }) => {
	const [lineIndex, setLineIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setLineIndex(prev => (prev + 1) % FLAVOR_LINES.length);
		}, 900);
		return () => clearInterval(interval);
	}, []);

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-ink z-50 overflow-hidden">
			<div
				className="absolute inset-0 opacity-20"
				style={{
					backgroundImage:
						'radial-gradient(rgba(201,164,74,0.35) 1px, transparent 1px)',
					backgroundSize: '24px 24px',
				}}
			/>
			<div className="relative w-full flex flex-col items-center justify-center px-4">
				<h1 className="font-display text-2xl md:text-4xl tracking-widest text-gold mb-8 text-center">
					LOADING WORLD&hellip;
				</h1>
				<div className="w-[500px] max-w-[90vw]">
					<div className="flex justify-between mb-2 px-1 font-mono text-sm">
						<span className="text-gray-400">{FLAVOR_LINES[lineIndex]}</span>
						<span className="text-gold">{progress}%</span>
					</div>
					<div className="w-full h-3 bg-panel2 rounded-sm overflow-hidden border border-gold/30">
						<div
							className="relative h-full overflow-hidden bg-gradient-to-r from-gold to-legendary transition-all duration-300 shadow-[0_0_12px_rgba(245,166,35,0.7)]"
							style={{ width: `${progress}%` }}
						>
							<div
								className="absolute inset-0 opacity-30 animate-[shimmer-slide_1s_linear_infinite]"
								style={{
									backgroundImage:
										'repeating-linear-gradient(45deg, rgba(255,255,255,0.6) 0, rgba(255,255,255,0.6) 4px, transparent 4px, transparent 10px)',
								}}
								aria-hidden="true"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoaderV2;
